import { useEffect } from 'react'

/** Ce que l'onglet, l'écran d'accueil et le sélecteur de fenêtres montrent après l'écran. */
const APP_NAME = 'GHP Pilot — Terrain'

/**
 * Nomme l'écran courant dans le titre du document.
 *
 * Ce n'est pas de la décoration sur une tablette : l'app est **installable** (manifeste, D19), et
 * une PWA installée n'affiche ni URL ni onglet. Le titre est alors le seul repère du sélecteur
 * de tâches d'Android — deux fenêtres « GHP Pilot — Terrain » y sont indistinguables.
 *
 * Le titre trouvé en arrivant est rétabli au démontage : **tous les écrans n'appellent pas ce
 * hook**, et sans cette restitution le nom de l'écran qu'on quitte resterait dans le sélecteur
 * de tâches par-dessus le suivant — exactement le repère faux que ce hook existe pour éviter.
 */
export function useDocumentTitle(screen: string): void {
  useEffect(() => {
    const previous = document.title
    document.title = `${screen} · ${APP_NAME}`

    return () => {
      document.title = previous
    }
  }, [screen])
}
